<script>
import Anxunheader from "@/views/Anxun/component/Anxunheader.vue";
import kefu from "@/views/kefu.vue";
import headtip from "@/views/headTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import bottomTip from "@/views/bottomTip.vue";
import { shareUrl } from "@/utils/vxshare";
import consultTip from "@/components/consultTip.vue";
// Constants for page content
const PAGE_CONTENT = {
  headertitle1: " Software deployment and operation <br> and maintenance services \n\n\n",
  headertitle1Mobile: " Software deployment and operation maintenance services \n\n\n",
  headertitle2: "Full-process product support from installation and deployment to daily operation and maintenance to ensure stable operation and high availability of the system \n\n\n",
  headerimg: require("@/assets/Inspection1.png"),
  introduce: "Based on safety regulations and industry standards, we build a knowledge base of potential hazards and risks, and combine it with multi-terminal technologies to achieve risk management and control, hazard detection, rectification, acceptance, and management. Through intelligent analysis, prediction and early warning, and safety performance management, we improve the efficiency of safety management and the ability to control risks.\n"
};

// Desktop data
const SECTION_DATA = [
  {
    title: " Challenges and pain points",
    img: "/OM1.png"
  },
  {
    title: "Service content",
    title2: "System architecture optimization",
    img: "/OM2.png"
  },
  {
    title2: "7 times 24  Monitoring and fault recovery",
    img: "/OM3.png"
  },
  {
    title: "Customer income",
    img: "/OM4.png"
  }
];

// Mobile data
const MOBILE_SECTION_DATA = [
  {
    title: "Challenges and pain points",
    img: "/OM11.png"
  },
  {
    title: "Service content",
    title2: "System architecture optimization",
    img: "/OM12.png"
  },
  {
    title2: "7 times 24  Monitoring and fault recovery",
    img: "/OM13.png"
  },
  {
    title: "Customer income",
    img: "/OM14.png"
  }
];

export default {
  name: 'SoftwareOM',
  components: {
    bottomTip,
    kefuMobile,
    Anxunheader,
    kefu,
    headtip,
    consultTip,
  },
  data() {
    return {
      dialogVisible: false,
      title: '',
      model: false,
      texttotal: PAGE_CONTENT,
      data: SECTION_DATA,
      data2: MOBILE_SECTION_DATA,
      challenges: [
        {
          icon: require('@/assets/software/om/team.webp'),  // 团队图标
          title: ' Lack of professional Ops team',
          description: ' Lack of timely response ability and diagnostic support for complex problems, and relying on manual operation, it is prone to errors and difficult to trace the source, which further reduces the efficiency of operation and maintenance and aggravates the burden of operation and maintenance. '
        },
        {
          icon: require('@/assets/software/om/system.webp'),  // 系统图标
          title: 'Low system scalability',
          description: ' Fixed hardware configuration cannot be flexibly adjusted, which limits the flexibility of the system, resulting in a decrease in query efficiency when the data volume surges, affecting the user experience. '
        },
        {
          icon: require('@/assets/software/om/security.webp'),  // 安全图标
          title: ' Insufficient safety protection ',
          description: 'Sensitive data is not encrypted and stored, identityThe verification mechanism is weak and the protection rules are not perfect, which makes the system vulnerable to the threat of illegal acquisition, tampering and external attacks.'
        }
      ],
      serviceList: [
        {
          title: 'System architecture optimization ',
          items: [
            'Cloud and localization deployment support： Provide flexible deployment options to meet the needs of different scenarios. ',
            ' Multi-node redundancy design：mprove the disaster tolerance of the system through distributed architecture and avoid single-point failures. ',
            ' Dynamic expansion capability： Support the dynamic adjustment of resource allocation according to the business scale to ensure system performance. ',
            'Data consistency guarantee ： Use distributed transaction management technology to ensure cross-node data consistency.'
          ]
        },
        {
          title: '7 times 24  Monitoring and fault recovery ',
          items: [
            ' Real-time performance monitoring：Monitor CPU, memory, disk and other key indicators to detect abnormalities in time.',
            'Alarm notification：The multi-level alarm mechanism ensures that the problem is detected and dealt with as soon as possible. ',
            'Fast recovery strategy ： Formulate a perfect fault recovery plan to minimize downtime. ',
            'Data backup ： Back up important data regularly to prevent data loss caused by accidents. '
          ]
        }
      ],
      benefitList: [
        {
          icon: require('@/assets/software/om/benefit1.webp'),
          title: 'Lower costs, leaner IT operations',
          desc: ' Through automated operation and maintenance tools and intelligent monitoring systems, automatic fault detection and repair can be realized to reduce dependence on manual operation and maintenance.'
        },
        {
          icon: require('@/assets/software/om/benefit2.webp'),
          title: 'Guaranteed system stability enhancement',
          desc: 'Provide 7 times 24 Hourly real-time monitoring and rapid response mechanism to find and solve potential problems in time to avoid affecting business continuity. '
        },
        {
          icon: require('@/assets/software/om/benefit3.webp'),
          title: 'Guaranteed security posture improvement',
          desc: 'Combine intrusion detection, firewall strategy and security audit to imvemeprove the overall protection ability of the system, resist external attacks, and ensure business data security compliance.'
        }
      ]
    };
  },
  methods: {
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      const metaKeywords = document.querySelector('meta[name="keywords"]');

      if (metaDescription) {
        metaDescription.setAttribute('content', this.texttotal.headertitle2);
      }
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.texttotal.headertitle1);
      }
    },
    setback(index) {
      return index % 2;
    },
    ResizeContainer() {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.model = screenWidth <= 700;
    },
    setupShareData() {
      const url = window.location.href;
      const shareData = {
        url,
        pageTitle: this.texttotal.headertitle1,
        pageDescription: this.texttotal.headertitle2,
        pageKeywords: ''
      };
      shareUrl(shareData);
    },
    topTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    topTopmobile() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    clickConsult(item) {
      this.title = item;
      this.dialogVisible = true;
      sessionStorage.setItem('title', item);
    },
    hideDialog() {
      this.dialogVisible = false;
    }
  },
  mounted() {
    document.title = this.texttotal.headertitle1;
    this.setMetaTags();
    this.ResizeContainer();
  },
  created() {
    localStorage.setItem("home", 0);
    setTimeout(this.setupShareData, 1000);
  }
};
</script>

<template>
  <!-- Desktop Layout -->
  <div v-if="!model" ref="total" class="software-page">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="header-container">
      <headtip :changeVisable="changeVisable" @showDialog="showPartner" />
    </div>

    <kefu @toptop="topTop" />
    <Anxunheader :title1="texttotal.headertitle1" :title2="texttotal.headertitle2"
      @clickConsult="clickConsult('Software deployment and operation and maintenance services')" />

    <!-- <div v-for="(item, index) in data" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div> -->
    <!-- 新增业务痛点与挑战模块 -->
    <div class="content-section" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Challenges and pain points</div>
      <div class="challenges-list">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
      <!-- 新增服务内容模块 -->
      <div class="content-section" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Service content</div>
      <div class="service-content-list">
        <div v-for="(service, idx) in serviceList" :key="idx" class="service-content-card">
          <div class="service-content-title">{{ service.title }}</div>
          <ul class="service-content-ul">
            <li v-for="(item, i) in service.items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 新增客户收益模块 -->
    <div class="content-section" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title"> Customer income </div>
      <div class="benefit-list">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Layout -->
  <div v-else ref="totalModel" class="software-page-mobile">
    <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog" />
    <div class="mobile-header">
      <kefuMobile @topMobile="topTopmobile" />
      <headtip @showDialog="showPartner" />

      <div class="header-content">
        <div v-sliden-instep="{ duration: 800 }" class="logo-container">
          <img loading="lazy" src="@/assets/AnxunLogo.png" class="logo" />
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-red">
          {{ texttotal.headertitle1Mobile }}
        </div>
        <div v-sliden-instep="{ duration: 1600 }" class="header-title header-title-dark">
          {{ texttotal.headertitle2 }}
        </div>
      </div>

      <div class="header-footer">
        <div v-sliden-instep="{ duration: 2400 }" class="slogan">
          Oil & Gas Digitalization, Simple and Practical
        </div>
        <div class="inquiry-button" @click="clickConsult('Software deployment and operation and maintenance services')">
          Product Inquiry
        </div>
      </div>
    </div>

    <!-- <div v-for="(item, index) in data2" :key="index" class="content-section"
      :class="{ 'section-white': index % 2, 'section-blue': !(index % 2) }">
      <div v-if="item.title" v-sliden-in="{ duration: 800 }" class="section-title" v-html="item.title" />
      <div v-if="item.title2" v-sliden-in="{ duration: 800 }" class="section-subtitle" v-html="item.title2" />
      <img :src="require('@/assets/software' + item.img)" class="section-image" />
    </div> -->
    <div class="content-section" :style="{ 'background-color': '#ffffff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Challenges and pain points</div>
      <div class="challenges-list-mobile">
        <div v-for="(item, index) in challenges" :key="index" class="challenge-card" v-sliden-in="{ duration: 800 }">
          <div class="challenge-icon">
            <img :src="item.icon">
          </div>
          <div class="challenge-title">{{ item.title }}</div>
          <div class="challenge-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <div class="content-section" :style="{ 'background-color': '#e9f0fa' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Service content</div>
      <div class="service-content-list-mobile">
        <div v-for="(service, idx) in serviceList" :key="idx" class="service-content-card-mobile">
          <div class="service-content-title-mobile">{{ service.title }}</div>
          <ul class="service-content-ul-mobile">
            <li v-for="(item, i) in service.items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content-section" :style="{ 'background-color': '#fff' }">
      <div v-sliden-in="{ duration: 800 }" class="section-title">Customer income</div>
      <div class="benefit-list-mobile">
        <div v-for="(item, idx) in benefitList" :key="idx" class="benefit-card-mobile">
          <div class="benefit-icon">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="benefit-title">{{ item.title }}</div>
          <div class="benefit-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div ref="bottom">
      <bottomTip />
    </div>
  </div>
</template>

<style scoped lang="scss">
// 通用样式
.section-white {
  background-color: white;
}

.section-blue {
  background-color: #ebf1fd;
}

.section-image {
  margin: auto;
}

// 桌面版样式
.software-page {
  .header-container {
    height: 6vh;
    background-color: rgb(245 244 246);
    position: fixed;
    z-index: 10;
    padding-left: 3vw;
    width: 100%;
  }

  .content-section {
    padding: 5.78739184177998vh 8.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2.2060658579vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 2vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-image {
      width: 70vw;
    }
    // 新增pc端客户痛点与挑战模块样式
    .challenges-list {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      .challenge-card {
        // flex: 1;
        margin: 0 15px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 20px;

          img {
            width: 70px;
            height: 70px;
          }
        }

        .challenge-title {
          font-size: 24px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 15px;
          
        }

        .challenge-desc {
          font-size: 16px;
          color: #333;
          line-height: 1.6;
          text-align: left;
          max-width: 350px; // 添加最大宽度限制
          margin: 0 auto;
        }
      }
    }
    // 新增pc端服务内容模块样式
    .service-content-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .service-content-card {
        background: #fff;
        border: 1.5px solid #b6c6e3;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
        padding: 32px 36px;
        min-width: 320px;
        max-width: 600px;
        flex: 1;
        display: flex;
        flex-direction: column;
        // align-items: flex-start;

        .service-content-title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 18px;
          color: #000000;
          text-align: center;
        }

        .service-content-ul {
          padding-left: 18px;

          li {
            font-size: 16px;
            color: #333;
            line-height: 2;
            list-style: disc;
          }
        }
      }
    }
    // 新增pc端客户收益模块样式
        .benefit-list {
      display: flex;
      justify-content: space-between;
      gap: 40px;
      margin-top: 30px;
      flex-wrap: wrap;

      .benefit-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(44, 100, 200, 0.18), 0 1.5px 6px rgba(44, 100, 200, 0.12);

        padding: 40px 32px 92px 32px;
        min-width: 260px;
        max-width: 380px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .benefit-icon {
          margin-bottom: 24px;

          img {
            width: 150px;
            height: 150px;
          }
        }

        .benefit-title {
          font-size: 24px;
          font-weight: bold;
          color: #222;
          margin-bottom: 18px;
          text-align: center;
          line-height: 1.4;
        }

        .benefit-desc {
          font-size: 16px;
          color: #333;
          // text-align: center;
          line-height: 1.8;
          min-height: 48px;
          max-width: 320px; // 限制最大宽度
          margin: 0 auto;
        }
      }
    }
  }
}

// 移动版样式
.software-page-mobile {
  .mobile-header {
    position: relative;
    width: 100%;
    height: 670px;
    padding: 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../../assets/bannerModel.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;

    .header-content {
      position: absolute;
      top: 65px;
      left: 9.17157712305026vw;
      z-index: 2;

      .logo-container {
        width: 120px;
        margin: 10px 0;
      }

      .logo {
        width: 100%;
      }

      .header-title {
        margin-top: 5px;
        width: 95%;
        height: fit-content;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        line-height: 24px;

        &-red {
          font-weight: bolder;
          font-size: 20px;
          margin-top: 15px;
          line-height: 30px;
          color: #F44336;
        }

        &-dark {
          font-weight: bolder;
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: #2c3e50;
          text-align: left;
        }
      }
    }

    .header-footer {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);

      .slogan {
        width: 100vw;
        margin-bottom: 20px;
        font-weight: bolder;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        padding-bottom: 5px;
        color: #2f6dfd;
      }

      .inquiry-button {
        font-size: 14px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9.1px;
        width: fit-content;
        margin: auto;
        padding: 5px 4.6875vw;
        height: 35px;
        color: white;
        background-color: #2f6eff;
        border: 1px solid #2f6eff;
        overflow: hidden;
      }
    }
  }

  .content-section {
    padding: 1.78739184177998vh 2.09763142692085vw;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .section-title {
      margin: 0 auto;
      text-align: center;
      height: 5.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 6vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 4.23733003708282vh;
    }

    .section-subtitle {
      margin: 0 auto;
      text-align: center;
      height: 8.23733003708282vh;
      opacity: 1;
      font-weight: bold;
      font-size: 5vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      line-height: 3vh;
    }

    .section-image {
      width: 90vw;
    }
    .challenges-list-mobile {
      margin-top: 20px;

      .challenge-card {
        margin-bottom: 30px;
        text-align: center;

        .challenge-icon {
          margin-bottom: 15px;

          img {
            width: 50px;
            height: 50px;
          }
        }

        .challenge-title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          margin-bottom: 10px;
        }

        .challenge-desc {
          font-size: 14px;
          color: #333;
          line-height: 1.5;
          text-align: left;
          max-width: 260px; // 移动端可以设置稍小的宽度
          margin: 0 auto;
        }
      }
    }
    .service-content-list-mobile {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 20px;

      .service-content-card-mobile {
        background: #fff;
        border: 1.5px solid #b6c6e3;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
        padding: 20px 20px;
        width: 100%;

        .service-content-title-mobile {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 12px;
          color: #000000;
          text-align: center;
        }

        .service-content-ul-mobile {
          padding-left: 18px;

          li {
            font-size: 14px;
            color: #333;
            line-height: 2;
            list-style: disc;
          }
        }
      }
    }
    .benefit-list-mobile {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;

    .benefit-card-mobile {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
      padding: 24px 12px 18px 12px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .benefit-icon {
        margin-bottom: 16px;

        img {
          // width: 48px;
          // height: 48px;
          width: 100px;
          height: 100px;
        }
      }

      .benefit-title {
        font-size: 16px;
        font-weight: bold;
        color: #222;
        margin-bottom: 10px;
        text-align: center;
        line-height: 1.4;
      }

      .benefit-desc {
        font-size: 14px;
        color: #333;
        text-align: center;
        line-height: 1.7;
        min-height: 36px;
      }
    }
  }
  }
}
</style>